import script from "./AccordionListItemTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionListItemTwo.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionListItemTwo.vue?vue&type=style&index=0&id=47f02bd4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f02bd4"]])

export default __exports__